import React from "react";
import { adminRoutes } from "./admin.routes";
import { authRoutes } from "./auth.routes";
import { IRoute } from "./interfaces/route.interface";
import { propertiesRoutes } from "./properties.routes";
import { tenantRoutes } from "./tenant.routes";
import { flattenRoutes } from "./utils/flatten-routes";

const HomePage = React.lazy(() =>  import("../pages/HomePage"));

const indexRoutes:IRoute[] = [
    {
        path: "/",
        exact: true,
        component: HomePage,
        privateRoute: true,
    },
];

const routesArray:Array<IRoute[]> = [ 
    indexRoutes,
    authRoutes,
    propertiesRoutes,
    adminRoutes,
    tenantRoutes,
];

export const routes = flattenRoutes(routesArray);